'use client';

import { ShowcaseIcon } from '../../collection-showcase/scenes/scene-primitives.jsx';
import { BlurSwap } from '../../collection-showcase/scenes/playback-controls.jsx';

// Recovered from the IMAI v5 animation source; demo documents stay illustrative.
import * as React from 'react';
import {
  ShowcaseCopyContext,
  translateShowcaseNode,
} from '../../collection-showcase/translation';
import { Br, Nr, zr } from './apps-animation';
import { BusinessIcon } from './business-primitives';
import { C } from './business-facts';
export function WorkbookGrid({
  columns: e,
  rows: t,
  t: n,
  pick: r,
  label: i,
  extra: a = 0,
  minRows: o = 0,
}) {
  const showcaseCopy = React.use(ShowcaseCopyContext);
  let s = [
      ...e,
      ...Array.from(
        {
          length: a,
        },
        () => Br
      ),
    ],
    c = [
      ...t,
      ...Array.from(
        {
          length: Math.max(0, o - t.length),
        },
        () => ({
          cells: [],
          pad: !0,
        })
      ),
    ],
    l = (e) =>
      `36px ${s
        .filter((t) => e || !t.hideSm)
        .map((t) => (e ? t.w : (t.xs ?? t.w)))
        .join(' ')}`,
    u = (e) => (e?.hideSm ? 'max-sm:hidden' : '');
  return (
    <div
      role={'table'}
      aria-label={translateShowcaseNode(showcaseCopy, i)}
      className={
        'num grid [grid-template-columns:var(--c)] text-[12px] leading-4 sm:[grid-template-columns:var(--w)]'
      }
      style={{
        '--w': l(!0),
        '--c': l(!1),
      }}
    >
      <span
        aria-hidden={!0}
        className={
          'h-6 border-r border-b border-[var(--border)] bg-[var(--muted)]'
        }
      />
      {translateShowcaseNode(
        showcaseCopy,
        s.map((e, t) => (
          <span
            key={Nr[t]}
            aria-hidden={!0}
            className={`flex h-6 items-center justify-center border-r border-b border-[var(--border)] text-[12px] font-medium transition-colors duration-150 ${r?.c === t ? 'text-ink bg-[color-mix(in_srgb,var(--sheet-pick)_16%,var(--muted))]' : 'text-ink bg-[var(--muted)]'} ${u(e)}`}
          >
            {translateShowcaseNode(showcaseCopy, Nr[t])}
          </span>
        ))
      )}
      {translateShowcaseNode(
        showcaseCopy,
        c.map((e, t) => (
          <div
            key={t}
            role={e.pad ? 'presentation' : 'row'}
            className={
              e.pad
                ? 'contents max-lg:[&>*]:hidden'
                : e.hideXs
                  ? 'contents max-sm:[&>*]:hidden'
                  : 'contents'
            }
          >
            <span
              aria-hidden={!0}
              className={`flex ${e.tall ? 'h-10' : 'h-8'} items-center justify-end border-r border-b border-[var(--border)] px-2 text-[12px] transition-colors duration-150 ${r?.r === t ? 'text-ink bg-[color-mix(in_srgb,var(--sheet-pick)_16%,var(--muted))]' : 'text-ink-3 bg-[color-mix(in_oklch,var(--muted)_70%,transparent)]'}`}
            >
              {translateShowcaseNode(showcaseCopy, t + 1)}
            </span>
            {translateShowcaseNode(
              showcaseCopy,
              s.map((i, a) => {
                let o = e.cells[a] ?? {},
                  s = o.at === void 0 || n >= o.at,
                  c = r?.r === t && r?.c === a,
                  l =
                    i.align === 'right'
                      ? 'justify-end text-right'
                      : i.align === 'center'
                        ? 'justify-center'
                        : '',
                  d =
                    o.tone === 'muted'
                      ? 'text-ink-3'
                      : o.tone === 'warn'
                        ? 'text-[var(--ref-amber)]'
                        : o.tone === 'good'
                          ? 'text-[oklch(0.52_0.13_155)]'
                          : 'text-ink';
                return (
                  <span
                    key={`${t}-${a}`}
                    role={'cell'}
                    className={`relative flex ${e.tall ? 'h-10' : 'h-8'} min-w-0 items-center border-r border-b border-[var(--border)] px-2 ${l} ${d} ${e.head ? 'bg-[var(--sheet-head)] font-semibold' : e.total ? 'bg-[var(--background)] font-semibold' : 'bg-[var(--background)]'} ${o.bold ? 'font-semibold' : ''} ${u(i)}`}
                  >
                    {translateShowcaseNode(
                      showcaseCopy,
                      s ? (
                        <span
                          key={o.flashKey ?? 'v'}
                          className={`truncate ${o.at !== void 0 || o.flashKey ? 'bz-cell-in' : ''}`}
                        >
                          {translateShowcaseNode(showcaseCopy, zr(o))}
                        </span>
                      ) : null
                    )}
                    {translateShowcaseNode(
                      showcaseCopy,
                      s && (o.f || o.flashKey) ? (
                        <span
                          key={`flash-${o.flashKey ?? o.at}`}
                          aria-hidden={!0}
                          className={
                            'bz-flash pointer-events-none absolute inset-0'
                          }
                        />
                      ) : null
                    )}
                    {translateShowcaseNode(
                      showcaseCopy,
                      c ? (
                        <span
                          aria-hidden={!0}
                          className={
                            'pointer-events-none absolute -inset-px z-[2] shadow-[inset_0_0_0_2px_var(--sheet-pick)]'
                          }
                        />
                      ) : null
                    )}
                  </span>
                );
              })
            )}
          </div>
        ))
      )}
    </div>
  );
}
export function WorkbookWindow({
  title: e,
  version: t,
  file: n,
  tabs: r,
  activeTab: i,
  formula: a,
  approved: o = !1,
  meta: s,
  children: c,
  footer: l,
}) {
  const showcaseCopy = React.use(ShowcaseCopyContext);
  return (
    <div
      className={
        'bz-sheet flex min-w-0 flex-col overflow-hidden rounded-[10px] bg-[var(--background)] shadow-[var(--sh-1)]'
      }
    >
      <div
        className={
          'flex min-h-11 shrink-0 items-center justify-between gap-2 border-b border-[var(--border)] px-2 py-1.5 pl-3'
        }
      >
        <div className={'flex min-w-0 items-baseline gap-1.5 text-[12px]'}>
          <span className={'text-ink truncate font-medium'}>
            <BlurSwap value={e} />
          </span>
          <span className={'text-ink-3 shrink-0'}>
            {translateShowcaseNode(showcaseCopy, t)}
          </span>
          <BusinessIcon
            name={'info'}
            className={'text-ink-3 size-3.5 shrink-0 self-center'}
          />
          {translateShowcaseNode(showcaseCopy, s)}
        </div>
        <div className={'flex shrink-0 items-center gap-1'}>
          <span className={'text-ink-4 hidden items-center gap-0.5 md:flex'}>
            <span className={'grid size-8 place-items-center'}>
              <BusinessIcon name={'undo'} className={'size-4'} />
            </span>
            <span className={'grid size-8 place-items-center opacity-50'}>
              <BusinessIcon name={'redo'} className={'size-4'} />
            </span>
          </span>
          <span
            className={`flex h-8 items-center gap-1.5 rounded-md px-2.5 text-[12px] font-medium transition-[background-color,color,box-shadow] duration-200 ${o ? 'text-ink bg-[var(--background)] shadow-[inset_0_0_0_1px_var(--border)]' : 'bg-[var(--primary)] text-[var(--primary-foreground)]'}`}
          >
            <ShowcaseIcon
              name={'check'}
              className={'size-3.5'}
              strokeWidth={2}
            />
            <BlurSwap value={o ? 'Approved' : 'Approve sheet'} />
          </span>
          <span
            className={
              'text-ink hidden h-8 items-center gap-1.5 rounded-md px-2.5 text-[12px] lg:flex'
            }
          >
            <BlurSwap value={n} />
            <BusinessIcon name={'external'} className={'size-3.5'} />
          </span>
          <span
            className={'text-ink-3 hidden size-8 place-items-center sm:grid'}
          >
            <BusinessIcon name={'download'} className={'size-4'} />
          </span>
        </div>
      </div>
      <div
        aria-hidden={!0}
        className={
          'flex h-8 shrink-0 items-center border-b border-[var(--border)] text-[12px]'
        }
      >
        <span
          className={
            'text-ink num flex h-full w-14 shrink-0 items-center justify-center border-r border-[var(--border)] font-mono text-[11.5px]'
          }
        >
          {translateShowcaseNode(showcaseCopy, a?.ref ?? 'A1')}
        </span>
        <span className={'text-ink-4 px-2.5 font-serif text-[13px] italic'}>
          {translateShowcaseNode(showcaseCopy, 'fx')}
        </span>
        <span className={'text-ink min-w-0 truncate font-mono text-[11.5px]'}>
          {translateShowcaseNode(showcaseCopy, a?.text ?? '')}
          {translateShowcaseNode(
            showcaseCopy,
            a?.typing ? <span className={'bz-caret'} /> : null
          )}
        </span>
      </div>
      <div className={'relative min-h-0 flex-1 overflow-hidden'}>
        {translateShowcaseNode(showcaseCopy, c)}
      </div>
      {translateShowcaseNode(showcaseCopy, l)}
      <div
        className={
          'flex shrink-0 [scrollbar-width:none] gap-1 overflow-x-auto border-t border-[var(--border)] px-2 py-1.5'
        }
      >
        {translateShowcaseNode(
          showcaseCopy,
          r.map((e, t) => (
            <span
              key={e}
              className={`flex h-7 shrink-0 items-center rounded-full border px-3 text-[12px] transition-colors duration-200 ${t === i ? 'border-[color-mix(in_oklch,var(--foreground)_20%,transparent)] bg-[var(--foreground)] text-[var(--background)]' : 'text-ink-3 border-[color-mix(in_oklch,var(--border)_70%,transparent)] bg-[color-mix(in_oklch,var(--muted)_30%,transparent)]'}`}
            >
              {translateShowcaseNode(showcaseCopy, e)}
            </span>
          ))
        )}
      </div>
    </div>
  );
}
export const Ur = C.inputs;
export const Wr = 1e3;
export const Gr = [4, 8, 13];
export const Kr = Array.from(
  {
    length: C.weeks,
  },
  (e, t) => t + 1
);
export const qr = ['Oct 7', 'Oct 14', 'Oct 21', 'Oct 28', 'Nov 4', 'Nov 11'];
export const Jr = (e) =>
  (Ur.onlinePerWeek +
    Ur.storePerWeek +
    (e === Ur.wholesaleDeposit.week ? Ur.wholesaleDeposit.amount : 0)) /
  Wr;
export const Yr = (e) =>
  (Ur.marketingPerWeek +
    (e % 2 == 1 ? Ur.payrollBiweekly : 0) +
    (Gr.includes(e) ? Ur.rentMonthly : 0) +
    Ur.productionPayments
      .filter((t) => t.week === e)
      .reduce((e, t) => e + t.amount, 0)) /
  Wr;
export const Xr = C.closing.base.map((e) => e / Wr);
export const Zr = C.closing.downside.map((e) => e / Wr);
export const Qr = C.low;
export const $r = 6;
export const ei = [
  {
    w: '128px',
    xs: 'minmax(0,1fr)',
  },
  ...Array.from(
    {
      length: $r,
    },
    (e, t) => ({
      w: '68px',
      xs: '58px',
      align: 'right',
      hideSm: t >= 3,
    })
  ),
];
export const ti = (e) => 420 + e * 420;
export const ni = 'ABCDEFG';
